import React from "react";
import { Container } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  PageContainer,
  ContentBox,
  Title,
  LastUpdated,
  SectionTitle,
  Paragraph,
} from "./PrivacyPage.styled";

const PrivacyPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PageContainer>
      <Container maxWidth="md">
        <ContentBox>
          <Title>{t("privacy.title")}</Title>
          <LastUpdated>{t("privacy.lastUpdated")}</LastUpdated>

          <Paragraph>{t("privacy.intro")}</Paragraph>

          <SectionTitle>
            {t("privacy.sections.informationWeCollect.title")}
          </SectionTitle>
          <Paragraph>
            {t("privacy.sections.informationWeCollect.content")}
          </Paragraph>

          <SectionTitle>
            {t("privacy.sections.hipaaCompliance.title")}
          </SectionTitle>
          <Paragraph>{t("privacy.sections.hipaaCompliance.content")}</Paragraph>

          <SectionTitle>
            {t("privacy.sections.howWeUseInformation.title")}
          </SectionTitle>
          <Paragraph>
            {t("privacy.sections.howWeUseInformation.content")}
          </Paragraph>

          <SectionTitle>
            {t("privacy.sections.dataStorageAndRetention.title")}
          </SectionTitle>
          <Paragraph>
            {t("privacy.sections.dataStorageAndRetention.content")}
          </Paragraph>

          <SectionTitle>
            {t("privacy.sections.accessAndControl.title")}
          </SectionTitle>
          <Paragraph>
            {t("privacy.sections.accessAndControl.content")}
          </Paragraph>

          <SectionTitle>
            {t("privacy.sections.securityMeasures.title")}
          </SectionTitle>
          <Paragraph>
            {t("privacy.sections.securityMeasures.content")}
          </Paragraph>

          <SectionTitle>
            {t("privacy.sections.thirdPartyServices.title")}
          </SectionTitle>
          <Paragraph>
            {t("privacy.sections.thirdPartyServices.content")}
          </Paragraph>

          <SectionTitle>
            {t("privacy.sections.childrensPrivacy.title")}
          </SectionTitle>
          <Paragraph>
            {t("privacy.sections.childrensPrivacy.content")}
          </Paragraph>

          <SectionTitle>
            {t("privacy.sections.updatesToPolicy.title")}
          </SectionTitle>
          <Paragraph>{t("privacy.sections.updatesToPolicy.content")}</Paragraph>

          <SectionTitle>{t("privacy.sections.contactUs.title")}</SectionTitle>
          <Paragraph>
            {t("privacy.sections.contactUs.content")}
            <br />
            {t("privacy.sections.contactUs.email")}
          </Paragraph>
        </ContentBox>
      </Container>
    </PageContainer>
  );
};

export default PrivacyPage;
